import React from 'react'
import { Tag } from 'antd'
import { t } from 'i18next'
import { SLOT_COLORS } from '../../Common/Color'

export default function SlotTypeTag ({ type }) {
  return <Tag color={SLOT_COLORS[type]} variant='solid'>{t(`Admin.Slot.type.${type}`)}</Tag>
}
